// Pure logic for the Home "Getting started" checklist, so the steps + done-state
// are unit-tested without rendering.
export function gettingStartedSteps({ hasVerifiedSender, contacts, campaigns, broadcasts }) {
  return [
    {
      key: "sender",
      label: "Set up your sending domain or verify a sender",
      done: !!hasVerifiedSender,
      path: "/settings",
      cta: "Go to Settings",
    },
    {
      key: "contacts",
      label: "Add your first contacts",
      done: (contacts || 0) > 0,
      path: "/contacts",
      cta: "Add contacts",
    },
    {
      key: "send",
      label: "Create a campaign or broadcast",
      done: (campaigns || 0) > 0 || (broadcasts || 0) > 0,
      path: "/broadcasts",
      cta: "Create a broadcast",
    },
  ];
}

export function allDone(steps) {
  return (steps || []).length > 0 && steps.every((s) => s.done);
}

export function completedCount(steps) {
  return (steps || []).filter((s) => s.done).length;
}
